export const BREAKPOINTS = {
  "breakpoint-small-mobile": "480px",
  "breakpoint-mobile": "1024px",
  "breakpoint-tablet": "1280px",
};
